<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <form #form="ngForm" class="email-template-test-form">
        <h1>Test Email Templates</h1>
        <div class="ui-grid ui-grid-responsive ui-fluid">
          <div class="ui-grid-row">
            <label for="to" class="ui-grid-col-2 control-label"
              ><strong><span class="required">*</span>To:</strong></label
            >
            <div class="label-content ui-grid-col-3">
              <input
                id="to"
                name="to"
                type="text"
                class="form-control"
                [(ngModel)]="email.to"
                #to="ngModel"
                pInputText
                required
              />
            </div>
            <div [hidden]="to.valid || to.untouched" style="color: red">To is required</div>
          </div>

          <div class="ui-grid-row">
            <label for="code" class="ui-grid-col-2 control-label"
              ><strong><span class="required">*</span>Email Template:</strong></label
            >
            <div class="label-content ui-grid-col-3">
              <select
                ngModel
                name="emailTemplate"
                [(ngModel)]="email.emailTemplateID"
                id="emailTemplate"
                class="form-control"
                #emailTemplate="ngModel"
                pInputText
                required
              >
                <option value=""></option>
                <option *ngFor="let emailTemplate of emailTemplates" [value]="emailTemplate.id">
                  {{ emailTemplate.code }}
                </option>
              </select>
            </div>
            <div [hidden]="emailTemplate.valid || emailTemplate.untouched" style="color: red">
              Email Template is required
            </div>
          </div>
        </div>
        <div class="ui-grid-row">
          <button pButton [disabled]="form.invalid" (click)="send()" label="Send"></button>
        </div>
      </form>
    </div>
  </div>
</div>
